/**
 * @generated SignedSource<<a0e22272fd240f82d79ed6cde3e07970>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RuleExcludeTxnInputObject = {
  perspectiveId?: string | null | undefined;
  ruleId: string;
  txnId: string;
};
export type ruleDetailPage_ExcludeTxnMutation$variables = {
  input: RuleExcludeTxnInputObject;
};
export type ruleDetailPage_ExcludeTxnMutation$data = {
  readonly ruleExcludeTxn: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rule: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type ruleDetailPage_ExcludeTxnMutation = {
  response: ruleDetailPage_ExcludeTxnMutation$data;
  variables: ruleDetailPage_ExcludeTxnMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rule",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ruleDetailPage_ExcludeTxnMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RuleExcludeTxnMutationPayload",
        "kind": "LinkedField",
        "name": "ruleExcludeTxn",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ruleDetailPage_ExcludeTxnMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RuleExcludeTxnMutationPayload",
        "kind": "LinkedField",
        "name": "ruleExcludeTxn",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "83d1f1b65ada4961f532fbc60b5102b3",
    "id": null,
    "metadata": {},
    "name": "ruleDetailPage_ExcludeTxnMutation",
    "operationKind": "mutation",
    "text": "mutation ruleDetailPage_ExcludeTxnMutation(\n  $input: RuleExcludeTxnInputObject!\n) {\n  ruleExcludeTxn(input: $input) {\n    rule {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f4d26a397e17f96b3a00eb6b3a45faf8";

export default node;
